import { KidsClubPage } from "~/components/kids-club/KidsClubPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/kids-club")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/kids-club"),
  component: KidsClubPage,
});
